import { S25Util } from "../util/s25-util";
import { DataAccess } from "../dataaccess/data.access";
import { GroupPreference } from "../pojo/GroupPreference";
import { UserprefService } from "./userpref.service";
import { Cache } from "../decorators/cache.decorator";

export class GroupPreferenceService {
    @Cache({ targetName: "GroupPreferenceService", immutable: true })
    public static async getGroupPreferences(
        prefNames: GroupPreference.prefNames[],
    ): Promise<GroupPreference.groupPreference[]> {
        const url = `/group_preferences.json?${DataAccess.params({ request_method: "get", filter: "active" })}`;

        const currentGroupId = await UserprefService.getGroupId();

        const payload = {
            group_preferences: {
                group_preference: prefNames.map((p) => {
                    return { group_id: currentGroupId, pref_name: p };
                }),
            },
        };

        const [response, error] = await S25Util.Maybe(
            DataAccess.post<{
                group_preferences: {
                    group_preference: GroupPreference.GroupPreferenceWs[];
                };
            }>(DataAccess.injectCaller(url, "GroupPreferenceService.getGroupPreferences"), payload),
        );

        if (error) {
            console.error("error getting group preferences", error);
            return [];
        }

        return response?.group_preferences?.group_preference?.map((groupPreference) => {
            return {
                prefName: groupPreference.pref_name,
                prefLabel: groupPreference.pref_label,
                prefValue: groupPreference.pref_value,
            };
        });
    }
}
